import {Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {fromEvent, Subject} from 'rxjs';
import {debounceTime, takeUntil} from 'rxjs/operators';
import {BudgetListFilter, BudgetListTableService} from '../../services/budget-list-table.service';
import {MatInputModule} from '@angular/material/input';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatIconModule} from '@angular/material/icon';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {FormsModule} from '@angular/forms';
import {CommonModule} from '@angular/common';
import {MatButtonModule} from '@angular/material/button';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatMomentDateModule} from '@angular/material-moment-adapter';



@Component({
    selector: 'app-budget-list-filter',
    standalone: true,
    templateUrl: './budget-list-filter.component.html',
    imports: [
        CommonModule,
        MatFormFieldModule,
        MatInputModule,
        MatDatepickerModule,
        MatIconModule,
        MatSlideToggleModule,
        FormsModule,
        MatButtonModule,
        MatTooltipModule,
        MatMomentDateModule
    ],
    styleUrls: ['./budget-list-filter.component.scss']
})
export class BudgetListFilterComponent implements OnInit, OnDestroy {

    constructor(private budgetListTableService: BudgetListTableService) {
    }

    private unsubscribe$ = new Subject();

    @ViewChild('filterF', {
        static: true
    }) filterF: ElementRef;

    _iconFilter: string | null = null;
    _showExport = false;
    dateFrom: Date | null = null;
    dateTo: Date | null = null;

    ngOnInit() {
        fromEvent(this.filterF.nativeElement, 'input').pipe(
            takeUntil(this.unsubscribe$),
            debounceTime(500)
        ).subscribe(() => this.storeFilters());
        this.restoreFilters();
    }

    setIconFilter(iconFilter) {
        this._iconFilter = (iconFilter === this._iconFilter) ? null : iconFilter;
        this.storeFilters();
    }

    changeShowExports() {
        this._showExport = !this._showExport;
        this.storeFilters();
    }

    clearFilter() {
        this.filterF.nativeElement.value = '';
        this.storeFilters();
    }

    clearDateRange() {
        this.dateFrom = null;
        this.dateTo = null;
        this.storeFilters();
    }

    restoreFilters() {
        const filter = this.budgetListTableService.retrieveFiltersFromStorage();

        this.filterF.nativeElement.value = filter.filter;
        this._showExport = filter.showExport;
        this._iconFilter = filter.status;
        this.dateFrom = filter.dateFrom ? new Date(filter.dateFrom) : null;
        this.dateTo = filter.dateTo ? new Date(filter.dateTo) : null;
    }

    storeFilters() {
        const filter: BudgetListFilter = {
            filter: this.filterF.nativeElement.value.trim(),
            showExport: this._showExport,
            status: this._iconFilter,
            dateFrom: this.dateFrom ? this.dateFrom.toISOString() : null,
            dateTo: this.dateTo ? this.dateTo.toISOString() : null
        };

        this.budgetListTableService.storeFilters(filter);
    }

    ngOnDestroy() {
        this.unsubscribe$.next(null);
        this.unsubscribe$.complete();
    }
}